import { connect } from 'react-redux'
import { withFormFields } from 'shared/ui'
import { email } from 'util/validation'
import {
  doUpdateCurrentUserForOnboarding,
  doResendConfirmationToken,
} from 'ducks/currentUser/operations'
import View from './view'

const validators = {
  email,
}

const select = () => ({
  initialValues: {
    email: '',
  },
  validators,
})

const perform = dispatch => {
  return {
    onSave: fields => {
      dispatch(doUpdateCurrentUserForOnboarding(fields)).then(() => {
        // HACK (jscheel): This should be on backend, but this is faster than
        // figuring out why devise confirmable isn't resending when it should.
        dispatch(doResendConfirmationToken())
      })
    },
  }
}

const EmailForm = connect(select, perform)(withFormFields(View))

export default EmailForm
